import React, { useState } from "react";
import aboutimg from "../static/media/r1.jpg";
import data from "../static/info/data";

export default function About() {
  const [showMore, setShowMore] = useState(false);
  return (
    <>
      <div
        className="about-container flex justify-center items-center"
        id="about"
      >
        <div className="about-wrapper justify-evenly flex flex-col lg:flex-row-reverse">
          <div className="about-img self-center lg:self-auto lg:mt-14">
            <img
              className="rounded-full w-[260px] h-[260px] md:w-[350px] md:h-[350px] object-cover"
              src={aboutimg}
              alt=""
            />
          </div>
          <div
            className="about-desc text-center lg:text-left"
            data-aos="fade-up"
            data-aos-duration="1500"
          >
            <div className="about-head">
              <h1 className="text-4xl font-bold">{data.aboutData.l1}</h1>
              <h2 className="text-base mt-2 sm:text-lg md:text-xl opacity-60 font-semibold">
                {data.aboutData.l2}
              </h2>
            </div>
            <hr />
            <h3 className="text-base sm:text-lg">
              {data.aboutData.content.description}
            </h3>
            {data.aboutData.content.areas.map((item, index) => (
              <>
                {index < 2 || showMore ? (
                  <>
                    <p className="text-heading opacity-60 font-semibold">
                      {item.name}
                    </p>
                    <h3 key={index} className="text-base sm:text-lg">
                      {item.description}
                    </h3>
                  </>
                ) : null}
              </>
            ))}
            {data.aboutData.content.areas.length > 3 && (
              <div>
                {!showMore ? (
                  <div
                    className="relative cursor-pointer"
                    onClick={() => setShowMore(true)}
                  >
                    <div className="blur-sm">
                      <p className="about-area text-heading font-semibold">
                        {data.aboutData.content.areas[2].name}
                      </p>
                      <h3 className="text-lg">
                        {data.aboutData.content.areas[2].description.substring(
                          0,
                          100
                        )}
                      </h3>
                    </div>
                    <button className="italic readmore mb-1">Read More</button>
                  </div>
                ) : (
                  <button
                    className="italic readmore"
                    onClick={() => setShowMore(false)}
                  >
                    Show Less
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
